import { useMutation } from '@tanstack/react-query';
import {
  type IndividualDiscountInput,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { feeKeys } from './keys';

const bulkApplyDiscounts = graphql(/* GraphQL */ `
  mutation fees_bulkApplyIndividualDiscounts(
    $input: [IndividualDiscountInput]
  ) {
    fees_bulkApplyIndividualDiscounts(input: $input) {
      success
    }
  }
`);

export function useBulkApplyDiscounts() {
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: (input: IndividualDiscountInput[]) =>
      gqlClient.request(bulkApplyDiscounts, { input }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: feeKeys.all });
      toast.success(t('common:snackbarMessages.updateSuccess'));
    },
    onError: () => {
      toast.error(t('common:snackbarMessages.errorFailed'));
    },
  });
}
